export enum ChatgptMediaType {
  Image = "IMAGE",
  Video = "VIDEO",
  Model3d = "MODEL_3D",
}
